var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3042 2.5C18.2408 2.5 19 3.26348 19 4.19218V17.8078C19 18.7424 18.2413 19.5 17.3042 19.5H3.7V16.1H2V14.4H3.7V11.85H2V10.15H3.7V7.6H2V5.9H3.7V2.5H17.3042ZM7.1 4.2H5.4V17.8H7.1V4.2ZM17.3 4.2H8.8V17.8H17.3V4.2Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/Notebook.3452c8afa92dad1a372ded7a42c92611.svg";
export { ForwardRef as ReactComponent };